import {Combo1, Option} from "../models/SGB";
import AppConstants from "./AppConstants";
import TickManager from "../service/TickManager";
import Quote from "../models/Quote";
import {ChainPositions} from "../models/ChainPositions";
import {SGBMarket} from "../models/SGBMarket";
import {Combo} from "../models/Combo";

function toggleFullScreen() {
    var e = window.document,
        l = e.documentElement,
        n =
            l.requestFullscreen,
            // ||
            // l.mozRequestFullScreen ||
            // l.webkitRequestFullScreen ||
            // l.msRequestFullscreen,
        t =
            e.exitFullscreen
    e.fullscreenElement ? t.call(e) : n.call(l);
}


class AppUtil {
    private map = new Map<string,boolean>()
    set mode(value: String) {
        this._mode = value;
    }

    genericSorter(sortBy:string, isAscending?:boolean):(a:any,b:any)=>number{
        if (sortBy==="")return ()=>1
        const isAsc = isAscending || (this.map.get(sortBy) || false)
        this.map.set(sortBy, !isAsc)
        return (a:any, b:any)=>isAsc?a[sortBy]-b[sortBy] : b[sortBy] - a[sortBy]
    }
    genericSorterWrapper(sortBy:string, isAscending?:boolean):() => (a: any, b: any) => number{
        return ()=>this.genericSorter(sortBy, isAscending)
    }

    genericSorterFun(name:string, sortFun:(a:any)=>number, isAscending?:boolean){
        const isAsc = isAscending || (this.map.get(name) || false)
        this.map.set(name, !isAsc)
        return (a:any, b:any)=>isAsc?sortFun(a)-sortFun(b) : -sortFun(a)+sortFun(b)
    }

    private _mode:String = AppConstants.MODE_NORMAL

    buyOpportunity(sgb: SGBMarket) {
        return sgb.minSeller>0 && sgb.minSeller < sgb.profitablePrice
    }

    sum(a:number, b:number){
        return a+b
    }

    toggleFullScreen() {
        toggleFullScreen()
    }

    groupBy<T>(arr: T[], fn: (item: T) => any):Record<string, T[]> {
        return arr.reduce<Record<string, T[]>>((prev, curr) => {
            const groupKey = fn(curr);
            const group = prev[groupKey] || [];
            group.push(curr);
            return { ...prev, [groupKey]: group };
        }, {});
    }

    maxBuyer(it: Option) {
        if (!it)return 0.0
        if(this._mode===AppConstants.MODE_NORMAL) {
            return it.miniTick.maxBuyer
        }
        else return it.miniTick.lastPrice
    }

    minSeller(it: Option) {
        if (!it)return 0.0
        if(this._mode===AppConstants.MODE_NORMAL) {
            return it.miniTick.minSeller
        }
        else return it.miniTick.lastPrice
    }

    getTime(last_trade_time: number):string {
        const date = new Date(last_trade_time)
        return  date.toDateString() + " " + date.toTimeString().split(" ")[0]
    }

    currentTime():number {
        return new Date().getTime()
    }

    getId(option: Combo) {
        return option.buyFut?.genInfo?.tradingsymbol+"_"+
            option.sellFut?.genInfo?.tradingsymbol+"_"+
            option.buyCall?.genInfo?.tradingsymbol+"_"+
            option.sellCall?.genInfo?.tradingsymbol+"_"+
            option.buyPut?.genInfo?.tradingsymbol+"_"+
            option.sellPut?.genInfo?.tradingsymbol+"_"
    }

    toFixed(num: number|string) {
        if (typeof num !== "string") {
            return num.toFixed(2)
        }
        return num
    }

    getRealTimeBuy(op: Option) {
        return this.minSeller(TickManager.getOption(op.genInfo.tradingsymbol))
    }

    getRealTimeSell(op: Option) {
        return this.maxBuyer(TickManager.getOption(op.genInfo.tradingsymbol))
    }

    fillIn(row: Combo) {
        if(row.type===AppConstants.ComboType.buyFutBuyPut){row = fillIns.buyFutBuyPut(row)}
        if(row.type===AppConstants.ComboType.buyCallSellCall){row = fillIns.buyCallSellCall(row)}
        if(row.type===AppConstants.ComboType.sellPutBuyPut){row = fillIns.sellPutBuyPut(row)}
        if(row.type===AppConstants.ComboType.buyCallSellFut){row = fillIns.buyCallSellFut(row)}
        if(row.type===AppConstants.ComboType.buyCallBuyPut){row = fillIns.buyCallBuyPut(row)}
        if(row.type===AppConstants.ComboType.sellPutSellFut){row = fillIns.buyCallSellFut(row)}
        if(row.type===AppConstants.ComboType.buyFutSellCall){row = fillIns.buyFutBuyPut(row)}
        if(row.type===AppConstants.ComboType.sellPutSellCall){row = fillIns.sellPutSellCall(row)}
        return row
    }

    getDiff(buy: Array<Quote>):number {
        return Math.abs(buy[0].price - buy[1].price)
    }

    getSpread(o: Option) {
        return o.miniTick.minSeller - o.miniTick.maxBuyer
    }

    filters<T>(filters: Array<(a:T)=>boolean>) {
        return (it:T) => filters.map(f=>f(it)).reduce((p,c)=>p&&c, true)
    }

    isITM(opt: Option, fut: Option) {
        return (opt.genInfo.instrument_type===AppConstants.PE && fut.miniTick.lastPrice < opt.genInfo.strike) ||
            (opt.genInfo.instrument_type===AppConstants.CE && fut.miniTick.lastPrice > opt.genInfo.strike)
    }

    getLacks(n:number|null|undefined) {
        if (n===null || n===undefined) return 0
        return (n/100000).toFixed(2) + "L"
    }

    getRoundedOff(num: number) {
        return (num.toString().indexOf("Infinity")!==-1 || num.toString().indexOf("NaN")!==-1) ? num : num.toFixed(2)
    }

    sort(a:number, b:number) {
        return a-b
    }

    notEmpty<T>(value: T | null | undefined): value is T {
        return value !== null && value !== undefined;
    }

    minOf(numbers: number[]) {
        return Math.min(...numbers)
    }

    getDate(expiry: number) {
        return new Date(expiry).toISOString().split("T")[0]
    }

    has(array: (any)[], elem: any) {
        return  array.indexOf(elem)!==-1
    }

    formatTimeForDay(time: number): string {
        const date = new Date(time);
        return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    }

    isToday(time:number) {
        let date = new Date(time)
        const today = new Date();
        return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    }

    any(booleans: boolean[], b: boolean): boolean {
        return booleans.find(it => b===it)!==undefined;
    }
    exportChainPositionsCSV(positions: ChainPositions[]) {
        if (!positions.length) return;
        // Define headers for both group and nested positions
        const headers = [
            "Client ID",
            "Chain",
            "Trading Symbol",
            "Strike",
            "Instrument Type",
            "Exchange",
            "ITM",
            "Qty",
            "Avg Price",
            "Expiry",
            "Future price"
        ];
        const rows: string[][] = [];
        positions.forEach(pos => {
            let futPrice = pos.futurePrice
            pos.positions.forEach(row => {
                let inst = TickManager.getOption(row.tradingsymbol);
                rows.push([
                    pos.clientId,
                    pos.chain,
                    row.tradingsymbol,
                    inst.genInfo.strike,
                    inst.genInfo.instrument_type,
                    row.exchange,
                    (row.intrinsic>0).toString(),
                    row.quantity,
                    row.average_price,
                    this.getDate(row.expiry),
                    futPrice
                ].map((v: string | number | null | undefined) => v !== null ? String(v) : ""));
            });
        });
        const csvContent = [headers, ...rows]
            .map((e: string[]) => e.map((v: string) => (v !== null ? v.replace(/"/g, '""') : "")).map((v: string) => `"${v}"`).join(","))
            .join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "positions.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    getSymbols(combo: Combo) {
        let buys = [combo.buyCall, combo.buyPut, combo.buyFut].filter(
            (it): it is NonNullable<typeof it> => it != null
        ).map(it => it.genInfo.tradingsymbol);
        const sells = [combo.sellCall, combo.sellPut, combo.sellFut].filter(
            (it): it is NonNullable<typeof it> => it != null
        ).map(it => it.genInfo.tradingsymbol);
        return [buys, sells].toString()
    }
}

const fillIns = {
    buyCallBuyPut: function (row: Combo):Combo1 {
        let buyCall = row.buyCall!
        let buyPut = row.buyPut!
        let sellPut = row.sellPut!!
        let sellCall = row.sellCall
        let prem1 = appUtil.minSeller(buyCall)
        let prem2 = appUtil.minSeller(buyPut)
        let prem3 = sellPut ? appUtil.maxBuyer(sellPut) : 0
        let prem4 = sellCall ? appUtil.maxBuyer(sellCall) : 0
        let prem1A = appUtil.getRealTimeBuy(buyCall);
        let prem2A = appUtil.getRealTimeBuy(buyPut);
        let prem3A = sellCall ? appUtil.getRealTimeSell(sellCall) : 0
        let prem4A = sellPut ? appUtil.getRealTimeSell(sellPut) : 0
        let ts1 = buyCall.genInfo.tradingsymbol
        let ts2 = buyPut.genInfo.tradingsymbol
        let ts3 = sellPut?.genInfo.tradingsymbol || "-"
        let ts4 = sellCall?.genInfo.tradingsymbol || "-"
        let ans = {...row}
        ans.symbols = `${ts1} ${ts2} ${ts3} ${ts4}`
        ans.calc = row.soldAt - row.boughtAt - (prem1 + prem2) + (prem3 + prem4)
        ans.minProfitA = row.soldAt - row.boughtAt - (prem1A + prem2A) + (prem3A + prem4A)
        ans.calcText = `${row.soldAt} - ${row.boughtAt} - (${prem1} + ${prem2}) + (${prem3} + ${prem4})`
        ans.calcTextA = `${row.soldAt} - ${row.boughtAt} - (${prem1A} + ${prem2A}) + (${prem3A} + ${prem4A})`
        return ans
    },
    buyCallSellCall: function (row: Combo) {
        let buyCall = row.buyCall!
        let sellCall = row.sellCall!
        let prem1 = appUtil.minSeller(buyCall)
        let prem2 = appUtil.maxBuyer(sellCall)
        let prem1A = appUtil.getRealTimeBuy(buyCall);
        let prem2A = appUtil.getRealTimeSell(sellCall)
        let ts1 = buyCall.genInfo.tradingsymbol
        let ts2 = sellCall.genInfo.tradingsymbol
        let ans = {...row}
        ans.calc = (-prem1 + prem2)
        ans.minProfitA = (-prem1A + prem2A)
        ans.calcText = `-${prem1} + ${prem2}`
        ans.calcTextA = `-${prem1A} + ${prem2A}`
        ans.symbols = `${ts1} ${ts2}`
        return  ans
    },
    buyCallSellFut: function (row: Combo) {
        let buyCall = row.buyCall
        let sellFut = row.sellFut!
        let sellPut = row.sellPut
        let prem1 = buyCall?appUtil.minSeller(buyCall) : 0
        let prem2 = sellPut ? appUtil.maxBuyer(sellPut) : 0
        let prem1A = buyCall?appUtil.getRealTimeBuy(buyCall):0;
        let prem2A = sellPut ? appUtil.getRealTimeSell(sellPut) : 0;
        let soldAtA = appUtil.getRealTimeSell(sellFut);
        let ts1 = buyCall?buyCall.genInfo.tradingsymbol:""
        let ts2 = sellFut.genInfo.tradingsymbol
        let ts3 = sellPut?.genInfo.tradingsymbol || "-"

        let ans = {...row}
        ans.calc = row.soldAt - row.boughtAt - prem1 + prem2
        ans.minProfitA = soldAtA - row.boughtAt - prem1A + prem2A
        ans.calcText = `${row.soldAt} - ${row.boughtAt} - ${prem1} + ${prem2}`
        ans.calcTextA = `${soldAtA} - ${row.boughtAt} - ${prem1A} + ${prem2A}`
        ans.symbols = `${ts1} ${ts2} ${ts3}`
        return ans
    },
    buyFutBuyPut: function (row: Combo) {
        let buyFut = row.buyFut!
        let buyPut = row.buyPut
        let sellCall = row.sellCall
        let prem1 = buyPut?appUtil.minSeller(buyPut):0
        let prem2 = sellCall ? appUtil.maxBuyer(sellCall) : 0
        let prem1A = buyPut?appUtil.getRealTimeBuy(buyPut):0;
        let prem2A = sellCall ? appUtil.getRealTimeSell(sellCall) : 0
        let boughtAtA = appUtil.getRealTimeBuy(buyFut);
        let ts1 = buyFut.genInfo.tradingsymbol
        let ts2 = buyPut?buyPut.genInfo.tradingsymbol:""
        let ts3 = sellCall?.genInfo.tradingsymbol || "-"
        let ans = {...row}
        ans.symbols = `${ts1} ${ts2} ${ts3}`
        ans.calc = row.soldAt - row.boughtAt - prem1 + prem2
        ans.minProfitA = row.soldAt - boughtAtA - prem1A + prem2A
        ans.calcText = `${row.soldAt} - ${row.boughtAt} - ${prem1} + ${prem2}`
        ans.calcTextA = `${row.soldAt} - ${boughtAtA} - ${prem1A} + ${prem2A}`
        return ans
    },
    sellPutBuyPut: function (row: Combo) {
        let buyPut = row.buyPut!
        let sellPut = row.sellPut!
        let prem1 = appUtil.minSeller(buyPut)
        let prem2 = appUtil.maxBuyer(sellPut)
        let prem1A = appUtil.getRealTimeBuy(buyPut);
        let prem2A = appUtil.getRealTimeSell(sellPut)
        let ts1 = buyPut.genInfo.tradingsymbol
        let ts2 = sellPut.genInfo.tradingsymbol

        let ans = {...row}
        ans.calc = (-prem1 + prem2)
        ans.minProfitA = (-prem1A + prem2A)
        ans.calcText = `-${prem1} + ${prem2}`
        ans.calcTextA = `-${prem1A} + ${prem2A}`
        ans.symbols = `${ts2} ${ts1}`
        return ans
    },
    sellPutSellCall: function (row: Combo) {
        // let buyCall = row.buyCall!
        // let buyPut = row.buyPut!
        let sellPut = row.sellPut!!
        let sellCall = row.sellCall!!
        let prem1 = 0
        let prem2 = 0
        let prem3 = appUtil.maxBuyer(sellPut)
        let prem4 = appUtil.maxBuyer(sellCall)
        let prem1A = 0
        let prem2A = 0
        let prem3A = appUtil.getRealTimeSell(sellCall)
        let prem4A = appUtil.getRealTimeSell(sellPut)
        let ts3 = sellPut.genInfo.tradingsymbol
        let ts4 = sellCall.genInfo.tradingsymbol
        let ans = {...row}
        ans.symbols = `${ts3} ${ts4}`
        ans.calc = row.soldAt - row.boughtAt - (prem1 + prem2) + (prem3 + prem4)
        ans.minProfitA = row.soldAt - row.boughtAt - (prem1A + prem2A) + (prem3A + prem4A)
        ans.calcText = `${row.soldAt} - ${row.boughtAt} - (${prem1} + ${prem2}) + (${prem3} + ${prem4})`
        ans.calcTextA = `${row.soldAt} - ${row.boughtAt} - (${prem1A} + ${prem2A}) + (${prem3A} + ${prem4A})`
        return ans
    }
}

export function catchError(err:any) {
    console.log(err)
}

export function percent(goldPrice:number,purchasePrice:number):string{
    if(purchasePrice===0)return "0"
    return (((goldPrice-purchasePrice)/purchasePrice)*100).toFixed(2)
}

export function getProfit(market:SGBMarket, type:string):string{
    switch (type) {
        case "buy": {
            return percent(market.goldPrice, market.minSeller)
        }
        case "bid" :{
            return percent(market.goldPrice, market.maxBuyer)
        }
        case "avg" :{
            return percent(market.goldPrice, market.sgb.tick.average_traded_price)
        }
        case "low" :{
            return percent(market.goldPrice, market.sgb.tick.ohlc.low)
        }
    }
    return ""
}

let appUtil = new AppUtil();
export default appUtil
